import type { UserAddress, UserAddressNew } from '../entities'
import { getGooglePlaceIdFromCoordinates } from '../use-cases'
import styles from './AddressBookModal.module.scss'
import { useDeliveryAddress } from '@/delivery-address/client'
import type { DeliveryAddress } from '@/delivery-address/entities'
import { BaseModalSize, DeviceType, ModalSheet, ModalSheetContent } from '@/tools/ui'
import { useDeviceMedia } from '@/tools/ui'
import { AddressBook } from '@/user/address-book/ui/AddressBook'
// TODO:
// Remove the export as soon as the react migration is completed and we don't need the
// internal address book pages (/app/language/internal/address-book-desktop + mobile)
export const mapUserAddressToDeliveryAddress = async (address: UserAddress | UserAddressNew) => {
  const deliveryAddress: DeliveryAddress = {
    latitude: address.latitude,
    longitude: address.longitude,
    cityCode: address.cityCode,
    countryCode: address.countryCode,
    cityName: address.cityName,
    text: address.addressLine,
    details: address.details,
    placeId: await getGooglePlaceIdFromCoordinates({
      latitude: address.latitude,
      longitude: address.longitude,
    }),
    isVerified: true,
  }
  return deliveryAddress
}

interface AddressBookModalProps {
  isOpen: boolean
  onClose: () => void
  onSelect: (address: UserAddress | UserAddressNew) => void
  verifiedAddress?: UserAddress | UserAddressNew
}

export const AddressBookModal = ({ isOpen, onClose, onSelect }: AddressBookModalProps) => {
  const { isNotMobile } = useDeviceMedia()
  const { setDeliveryAddress } = useDeliveryAddress()
  const shouldShowCloseButton = isNotMobile
  const handleOnClose = () => {
    onClose()
  }

  const handleSuccess = async (address: UserAddress | UserAddressNew) => {
    const deliveryAddress = await mapUserAddressToDeliveryAddress(address)
    await setDeliveryAddress(deliveryAddress)
    parent.postMessage({ type: 'ADDRESS_BOOK.CLOSE' }, '*')
    onSelect(address)
  }

  return (
    <ModalSheet
      className={styles.wrapper}
      fullscreen={DeviceType.mobile}
      isOpen={isOpen}
      showCloseButton={shouldShowCloseButton}
      size={BaseModalSize.small}
      onClose={handleOnClose}
    >
      <ModalSheetContent>
        <AddressBook onClose={handleOnClose} onSelect={handleSuccess} />
      </ModalSheetContent>
    </ModalSheet>
  )
}
